module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Bold-WebS.958ee133.ttf";